export default __webpack_public_path__ + "images/index_paralax_0.jpg";